import { useTheme } from '../context/ThemeContext';
import { useState } from 'react';
import { useAuth } from '../context/AuthContext';


const API = process.env.REACT_APP_API_URL || 'https://schirmerledger.app';

const Login = () => {
  const { COLORS } = useTheme();
  const { login } = useAuth();
  const [method, setMethod]     = useState("google");
  const [mode, setMode]         = useState("login"); // "login" | "signup"
  const [name, setName]         = useState("");
  const [email, setEmail]       = useState("");
  const [password, setPassword] = useState("");
  const [error, setError]       = useState("");
  const [loading, setLoading]   = useState(false);

  const handleGoogleLogin = () => {
    window.location.href = `${API}/auth/google`;
  };

  const handleEmailLogin = async () => {
    if (!email || !password) return;
    setLoading(true); setError("");
    try {
      await login(email, password);
    } catch (err) {
      setError(err.response?.data?.error || "Invalid email or password");
    } finally { setLoading(false); }
  };

  const handleSignup = async () => {
    if (!email || !password || !name) { setError("Name, email and password are required"); return; }
    setLoading(true); setError("");
    try {
      const res = await fetch(`${API}/api/auth/signup`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ name, email, password }),
      });
      const data = await res.json();
      if (!res.ok) throw new Error(data.error || "Signup failed");
      await login(email, password);
    } catch (err) {
      setError(err.message || "Signup failed");
    } finally { setLoading(false); }
  };

  return (
    <div style={{ minHeight: "100vh", background: COLORS.bg, display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", padding: 24, fontFamily: "'DM Sans', sans-serif" }}>
      <div style={{ textAlign: "center", marginBottom: 48 }}>
        <div style={{ width: 72, height: 72, borderRadius: 20, background: "linear-gradient(135deg, #3b82f6, #1d4ed8)", display: "flex", alignItems: "center", justifyContent: "center", fontSize: 34, margin: "0 auto 16px", boxShadow: "0 0 40px rgba(59,130,246,0.4)" }}>
          💰
        </div>
        <h1 style={{ color: COLORS.text, fontSize: 34, fontWeight: 800, margin: 0, letterSpacing: -1.5 }}>Ledger</h1>
        <p style={{ color: COLORS.textMuted, margin: "8px 0 0", fontSize: 15 }}>Your household budget, automated.</p>
      </div>

      <div style={{ width: "100%", maxWidth: 380, background: COLORS.surface, border: `1px solid ${COLORS.border}`, borderRadius: 20, padding: 28 }}>
        <div style={{ display: "flex", gap: 6, marginBottom: 24, background: COLORS.bg, padding: 4, borderRadius: 10 }}>
          {["google", "email"].map(m => (
            <button key={m} onClick={() => { setMethod(m); setError(""); }} style={{ flex: 1, padding: "9px", borderRadius: 8, border: "none", cursor: "pointer", fontFamily: "inherit", fontWeight: 600, fontSize: 14, background: method === m ? COLORS.accent : "transparent", color: method === m ? "#fff" : COLORS.textMuted }}>
              {m === "google" ? "Google" : "Email"}
            </button>
          ))}
        </div>

        {method === "google" ? (
          <>
            <button onClick={handleGoogleLogin} style={{ width: "100%", padding: "14px", background: "#fff", border: "none", borderRadius: 12, cursor: "pointer", fontFamily: "inherit", fontWeight: 600, fontSize: 15, color: "#1a1a1a", display: "flex", alignItems: "center", justifyContent: "center", gap: 10, marginBottom: 14 }}>
              <svg width="18" height="18" viewBox="0 0 18 18">
                <path fill="#4285F4" d="M17.64 9.2c0-.637-.057-1.251-.164-1.84H9v3.481h4.844c-.209 1.125-.843 2.078-1.796 2.717v2.258h2.908c1.702-1.567 2.684-3.874 2.684-6.615z"/>
                <path fill="#34A853" d="M9 18c2.43 0 4.467-.806 5.956-2.18l-2.909-2.259c-.806.54-1.837.86-3.047.86-2.344 0-4.328-1.584-5.036-3.711H.957v2.332A8.997 8.997 0 0 0 9 18z"/>
                <path fill="#FBBC05" d="M3.964 10.71A5.41 5.41 0 0 1 3.682 9c0-.593.102-1.17.282-1.71V4.958H.957A8.996 8.996 0 0 0 0 9c0 1.452.348 2.827.957 4.042l3.007-2.332z"/>
                <path fill="#EA4335" d="M9 3.58c1.321 0 2.508.454 3.44 1.345l2.582-2.58C13.463.891 11.426 0 9 0A8.997 8.997 0 0 0 .957 4.958L3.964 7.29C4.672 5.163 6.656 3.58 9 3.58z"/>
              </svg>
              Continue with Google
            </button>
            <p style={{ color: COLORS.textMuted, fontSize: 12, textAlign: "center", margin: 0, lineHeight: 1.6 }}>
              Unlocks Google Sheets sync to your Drive.<br />Required for household sharing.
            </p>
          </>
        ) : (
          <>
            {/* Login / Signup toggle */}
            <div style={{ display: "flex", gap: 6, marginBottom: 16, background: COLORS.bg, padding: 4, borderRadius: 10 }}>
              {["login", "signup"].map(m => (
                <button key={m} onClick={() => { setMode(m); setError(""); }} style={{ flex: 1, padding: "8px", borderRadius: 8, border: "none", cursor: "pointer", fontFamily: "inherit", fontWeight: 600, fontSize: 13, background: mode === m ? COLORS.accent : "transparent", color: mode === m ? "#fff" : COLORS.textMuted }}>
                  {m === "login" ? "Sign In" : "Create Account"}
                </button>
              ))}
            </div>

            {mode === "signup" && (
              <input value={name} onChange={e => setName(e.target.value)} placeholder="Full name"
                style={{ width: "100%", padding: "12px 14px", background: COLORS.bg, border: `1px solid ${COLORS.border}`, borderRadius: 10, color: COLORS.text, fontSize: 14, fontFamily: "inherit", marginBottom: 10, boxSizing: "border-box", outline: "none" }} />
            )}
            <input value={email} onChange={e => setEmail(e.target.value)} onKeyDown={e => e.key === 'Enter' && (mode === 'login' ? handleEmailLogin() : handleSignup())} placeholder="Email address"
              style={{ width: "100%", padding: "12px 14px", background: COLORS.bg, border: `1px solid ${error ? '#ef4444' : COLORS.border}`, borderRadius: 10, color: COLORS.text, fontSize: 14, fontFamily: "inherit", marginBottom: 10, boxSizing: "border-box", outline: "none" }} />
            <input value={password} onChange={e => setPassword(e.target.value)} onKeyDown={e => e.key === 'Enter' && (mode === 'login' ? handleEmailLogin() : handleSignup())} placeholder="Password" type="password"
              style={{ width: "100%", padding: "12px 14px", background: COLORS.bg, border: `1px solid ${error ? '#ef4444' : COLORS.border}`, borderRadius: 10, color: COLORS.text, fontSize: 14, fontFamily: "inherit", marginBottom: error ? 8 : 14, boxSizing: "border-box", outline: "none" }} />
            {error && <p style={{ color: '#ef4444', fontSize: 12, margin: "0 0 10px", textAlign: "center" }}>{error}</p>}
            <button onClick={mode === 'login' ? handleEmailLogin : handleSignup} disabled={loading} style={{ width: "100%", padding: "14px", background: COLORS.accent, border: "none", borderRadius: 12, cursor: "pointer", fontFamily: "inherit", fontWeight: 600, fontSize: 15, color: "#fff", opacity: loading ? 0.7 : 1 }}>
              {loading ? (mode === 'login' ? "Signing in..." : "Creating account...") : (mode === 'login' ? "Sign In" : "Create Account")}
            </button>
          </>
        )}
      </div>
    </div>
  );
};

export default Login;
